import React, { useContext, useEffect, useRef, useState } from "react";
import "./PartSelection.css";
import searchIcon from "../../assets/Icons/search_icon.svg";
import { Close, KeyboardArrowDown } from "@mui/icons-material";
import { Checkbox, Popover } from "@mui/material";
import { validateDropdownOption } from "../../modules/ConfigurationModule/services/PartsConfigurationService";
import { getDropdownData } from "../../services/dropdownsConfigService";
import { useDropdownGlobalData } from "../../contexts/DropdownGlobalDataContext";
import { FixedSizeList } from "react-window";
import { environment } from "../../environments/environment";
// import { DropdownGlobalDataContext } from "../../contexts/DropdownGlobalDataContext";

export const PartSelection = ({
  data, // receive configuration data of the dropdown , is MANDATORY for the operation of the dropdown component | object
  currentIndexTab, // is used to handle navegtion using tab key ( come from parent component) | number
  updateDropdown, // is very important if you need dropdown dependencies (come from parent component) | callback
  resetDropdownsReload, // also used to dropdown dependencies | callback
  onOptionSelect, // emits the selection event of any option in the dropdown | callback
  onAllOptionsSelected, // emits an event with all options selected by user , usefull if dropdown type is multiple selection | callback
  preSelectValue, // select the element than label match with this value | string,
  fixedLabel,
  required,
  onApplySelection,
  disabled,
  hideWhenDisabled,
  context,
  clearWhenChange = false,
  parentComponentId = null,
  externalOpening = false, // use when you need to open the dropdown from outside of the component , using some type of trigger
  activateErrorHint = false, // use when you need to show the error hint in the dropdown
  display2Grid = false, // use when you need to show the dropdown in 2 columns,
  children, // use to provide a custom HTML template that will be rendered instead of the default dropdown input.
  clearLabel, // Use to define a custom label for the "clear filter" button. Hides the button when set to null.
  display1Grid = false, // use when you need to show the dropdown in 1 column,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const [filterData, setFilterData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [filterSearchTerm, setFilterSearchTerm] = useState(() => {
    return "";
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(() => {
    return null;
  });
  const [filtersOptionsSelected, setFilterOptionsSelected] = useState([]);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [hiddenCount, setHiddenCount] = useState(0);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [labelsToShow, setLabelsToShow] = useState([]);
  const [primaryLabel, setPrimaryLabel] = useState(null);
  const [secondaryLabel, setSecondaryLabel] = useState(null);
  const containerRef = useRef(null);
  const activeOptionRef = useRef(null);

  const [touched, setTouched] = useState(null);
  const [errorLabel, setErrorLabel] = useState("");
  const { updatedropdownDataContext } = useDropdownGlobalData();

  useEffect(() => {
    if (isOpen && touched === null) setTouched(false);
    if (!isOpen && touched === false) setTouched(true);
  }, [isOpen, touched]);

  useEffect(() => {
    if (touched && required) {
      if (visibleOptions.length < 1) {
        setErrorLabel("Required");
      } else {
        setErrorLabel("");
      }
    }
  }, [touched, visibleOptions, required]);

  useEffect(() => {
    if (activateErrorHint && required && filtersOptionsSelected.length == 0) {
      setErrorLabel("Required");
    } else {
      setErrorLabel("");
    }
  }, [activateErrorHint, required, filtersOptionsSelected]);

  // functions

  const setGlobalDataOfDropdown = (values) => {
    // this function is used to set the global data of the dropdown in the context and can be used for the app to get datra of the options selected in the dropdown or dropdowns  including dropdown configuration info and hadle this data in the app.

    const dropdownData = {
      dropdownName: data.name,
      dropdownDescription: data.description,
      dropdownId: data.id,
      dropdownType: data.dropdownType,
      dropdownVersion: data.version,
      dropdownStatus: data.status,
      ValuesSelected: values,
    };

    updatedropdownDataContext(dropdownData);
  };

  const toggleMenu = (e) => {
    if (e) menuRef.current = e.currentTarget;
    setIsOpen((prev) => !prev);
  };

  const clearAllFilters = () => {
    setFilterOptionsSelected(() => {
      const updatedData = [];
      showSelectionsInLabel(updatedData);
      if (onAllOptionsSelected) {
        onAllOptionsSelected(updatedData);
      }
      return updatedData;
    });
  };

  const clearOneOptionFilter = (option) => {
    setFilterOptionsSelected((prevData) => {
      const updatedData = prevData.filter((e) => e != option);
      showSelectionsInLabel(updatedData);
      return updatedData;
    });
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      // setIsOpen(false);
    }
  };

  const handleInputChange = (event) => {
    setFilterSearchTerm(event.target.value);
  };

  const applySelection = (filtersOptionSelected) => {
    onApplySelection?.(filtersOptionSelected);
  };

  const showSelectionsInLabel = (options) => {
    if (options) {
      const container = document.getElementById("selected-options-container");
      if (!container) return;

      const containerWidth = container.offsetWidth;
      let currentWidth = 0;
      let visibleItemsCount = 0;
      const visibleOptions = [];

      options.forEach((option) => {
        const tempOption = document.createElement("span");
        tempOption.style.visibility = "hidden";
        tempOption.style.position = "absolute";
        tempOption.textContent = option[primaryLabel];
        container.appendChild(tempOption);

        const spanWidth = tempOption.getBoundingClientRect().width;
        container.removeChild(tempOption);

        switch (data.dropdownType) {
          case "Multiple Selection":
            if (currentWidth + spanWidth <= containerWidth) {
              currentWidth += spanWidth;
              visibleItemsCount++;
              visibleOptions.push(option);
            }
            break;
          case "Single Selection":
            visibleOptions.push(option);
            break;
        }
      });

      const hiddenCount = options.length - visibleItemsCount;
      setHiddenCount(hiddenCount);
      setVisibleOptions(visibleOptions);
    } else {
      setVisibleOptions([]);
    }
  };

  const getDropDownData = async (
    page,
    pageSize,
    isSearch = false,
    reload = false
  ) => {
    const filterId = data.id;

    const updatedDependencies = data.dependenciesToUpdate
      ? data.dependenciesToUpdate
          .filter((dep) => dep.childDropdownId === filterId)
          .map((dep) => ({
            ...dep,
            value: data.parentValues.map(
              (val) => val[dep.parentSqlstatementColumnName]
            ),
          }))
      : [];
    try {
      setLoading(true);
      let request;
      if (
        page === 0 &&
        !reload &&
        debouncedSearchTerm == "" &&
        context?.dropdownDefaultOptions?.[data.id]?.length > 0
      ) {
        request = {
          data: {
            responseCode: 200,
            load: context?.dropdownDefaultOptions?.[data.id] ?? [],
          },
        };
      } else {
        request = await getDropdownData(
          filterId,
          debouncedSearchTerm,
          updatedDependencies,
          page,
          pageSize,
          parentComponentId
        );
      }

      if (request.data.responseCode === 200) {
        if (isSearch) {
          setFilterData(request.data.load);
          setTotalRecords(request.data.totalRecords);
          setPage(1);
          if (clearWhenChange && preSelectValue === null) {
            setFilterOptionsSelected(() => {
              return [];
            });
            showSelectionsInLabel(null);

            data.dependencies.forEach((dependency) => {
              const { childDropdownId, parentSqlstatementColumnName } =
                dependency;

              const filteredDependencies = [
                {
                  ...dependency,
                  value: filtersOptionsSelected.map(
                    (item) => item[parentSqlstatementColumnName]
                  ),
                },
              ];

              // Actualizar el dropdown dependiente con las dependencias filtradas
              if (updateDropdown) {
                updateDropdown(
                  childDropdownId,
                  filteredDependencies,
                  data.dependencies
                );
              }
            });
          }

          //search;
        } else {
          // New Page
          setFilterData((prevData) => {
            // const updatedData = [...prevData, ...request.data.load.filter(option => !prevData.some(prevOption => prevOption.id === option.id))];
            const updatedData = [...prevData, ...request.data.load];

            return updatedData;
          });

          setTotalRecords(request.data.totalRecords);
          setPage((prevPage) => prevPage + 1);

          if (clearWhenChange && preSelectValue === null) {
            setFilterOptionsSelected(() => {
              return [];
            });
            showSelectionsInLabel(null);

            data.dependencies.forEach((dependency) => {
              const { childDropdownId, parentSqlstatementColumnName } =
                dependency;

              const filteredDependencies = [
                {
                  ...dependency,
                  value: filtersOptionsSelected.map(
                    (item) => item[parentSqlstatementColumnName]
                  ),
                },
              ];

              // Actualizar el dropdown dependiente con las dependencias filtradas
              if (updateDropdown) {
                updateDropdown(
                  childDropdownId,
                  filteredDependencies,
                  data.dependencies
                );
              }
            });
          }
        }

        if (data.firstRecordSelection) {
          selectFilterOption(request.data.load[0], 0, false, true);
          if (resetDropdownsReload) {
            resetDropdownsReload();
          }
        }

        if (data.oneRecAutoSelection) {
          if (filterData.length == 1) {
            selectFilterOption(request.data.load[0], 0, false, true);
            if (resetDropdownsReload) {
              resetDropdownsReload();
            }
          }
        }

        if (resetDropdownsReload) {
          resetDropdownsReload();
        }
      } else {
        // error
        setFilterData([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error(`Error fetching dropdown ${data.name} data:`, error);
    } finally {
      setLoading(false);
    }
  };

  const selectFilterOption = (
    option,
    index,
    preventSelectionEvent = false,
    toggle = false
  ) => {
    if (data.dropdownType === "Multiple Selection") {
      if (option) {
        if (toggle) {
          let selectedOption = filtersOptionsSelected.find(
            (opt) => opt.id === option.id
          );
          if (selectedOption) {
            clearOneOptionFilter(selectedOption);
            if (!preventSelectionEvent && onAllOptionsSelected) {
              onAllOptionsSelected(
                filtersOptionsSelected.filter((opt) => opt.id !== option.id)
              );
            }
            return;
          }
        }

        setFilterOptionsSelected((currentElements) => {
          const hasDuplicated = currentElements.some(
            (item) => item[primaryLabel] === option[primaryLabel]
          );

          if (!hasDuplicated) {
            const updatedOptions = [...currentElements, option];

            data.dependencies.forEach((dependency) => {
              const parentValues = updatedOptions.map((item) => ({
                [dependency.parentSqlstatementColumnName]:
                  item[dependency.parentSqlstatementColumnName],
              }));

              if (updateDropdown) {
                updateDropdown(
                  dependency.childDropdownId,
                  parentValues,
                  data.dependencies
                );
              }
            });

            showSelectionsInLabel(updatedOptions);
            if (!preventSelectionEvent && onOptionSelect) {
              onOptionSelect(option, data.selectedColumn);
            }

            if (!preventSelectionEvent && onAllOptionsSelected) {
              onAllOptionsSelected(updatedOptions);
            }
            setTimeout(() => {
              setGlobalDataOfDropdown(updatedOptions);
            }, 200);
            return updatedOptions;
          }

          return currentElements;
        });
      } else {
        setFilterOptionsSelected([]);
        showSelectionsInLabel([]);
      }
    } else {
      if (option) {
        setFilterOptionsSelected(() => {
          const updatedOption = [option];

          showSelectionsInLabel(updatedOption);
          if (!preventSelectionEvent && onOptionSelect) {
            onOptionSelect(option, data.selectedColumn);
          }

          setTimeout(() => {
            setGlobalDataOfDropdown(updatedOption);
          }, 200);

          data.dependencies.forEach((dependency) => {
            const parentValues = [
              {
                [dependency.parentSqlstatementColumnName]:
                  option[dependency.parentSqlstatementColumnName],
              },
            ];
            if (updateDropdown) {
              updateDropdown(
                dependency.childDropdownId,
                parentValues,
                data.dependencies
              );
            }
          });
          return updatedOption;
        });

        if (!preventSelectionEvent) setIsOpen(false);
      } else {
        setFilterOptionsSelected([]);
        showSelectionsInLabel([]);
        setTimeout(() => {
          data.dependencies.forEach((dependency) => {
            const { childDropdownId, parentSqlstatementColumnName } =
              dependency;

            const filteredDependencies = [
              {
                ...dependency,
                value: filtersOptionsSelected.map(
                  (item) => item[parentSqlstatementColumnName]
                ),
              },
            ];

            // Actualizar el dropdown dependiente con las dependencias filtradas
            if (updateDropdown) {
              updateDropdown(
                childDropdownId,
                filteredDependencies,
                data.dependencies
              );
            }
          });
        });
      }
    }

    setActiveIndex(index);
  };

  const loadMoreItems = () => {
    if (loading || filterData.length >= totalRecords) {
      return;
    }
    getDropDownData(page, environment.ElemensPerPage);
  };

  useEffect(() => {
    if (preSelectValue !== null && preSelectValue !== undefined) {
      validateDropdownOption(data.id, preSelectValue).then((response) => {
        if (response.data.responseCode === 200) {
          if (response.data.load?.[0])
            selectFilterOption(response.data.load[0], 1, true);
        }
      });
    }
    // else if (typeof preSelectValue === "string"){
    //   setFilterSearchTerm(preSelectValue)
    // }

    if (preSelectValue === null) {
      clearAllFilters();
    }
  }, [preSelectValue]);

  useEffect(() => {
    if (filtersOptionsSelected?.length > 0) {
      // Filtrar las dependencias relevantes para el dropdown dependiente
      data.dependencies.forEach((dependency) => {
        const { childDropdownId, parentSqlstatementColumnName } = dependency;

        const filteredDependencies = [
          {
            ...dependency,
            value: filtersOptionsSelected.map(
              (item) => item[parentSqlstatementColumnName]
            ),
          },
        ];

        // Actualizar el dropdown dependiente con las dependencias filtradas
        if (updateDropdown) {
          updateDropdown(
            childDropdownId,
            filteredDependencies,
            data.dependencies
          );
        }
      });
    }
  }, [filterData]);

  useEffect(() => {
    if (data.reload) {
      getDropDownData(0, environment.ElemensPerPage, true, true);
    }
  }, [data.reload]);

  useEffect(() => {
    if (data.labels && data.labels.length > 0) {
      const firstLabel = data.labels[0];
      const secondaryLabel = data.name == "IATA Code" ? data.labels[2] : null;

      setPrimaryLabel(firstLabel.sqlStatementColumnName);
      secondaryLabel &&
        setSecondaryLabel(secondaryLabel.sqlStatementColumnName);
    }
  }, [data]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (filterData.length === 0) return;

      if (isOpen) {
        if (event.key === "ArrowDown") {
          setActiveIndex((prevIndex) => (prevIndex + 1) % filterData.length);
        } else if (event.key === "ArrowUp") {
          setActiveIndex(
            (prevIndex) =>
              (prevIndex - 1 + filterData.length) % filterData.length
          );
        } else if (event.key === " ") {
          if (activeIndex >= 0) {
            const option = filterData[activeIndex];
            const isAlreadySelected = filtersOptionsSelected.some(
              (item) => item[primaryLabel] === option[primaryLabel]
            );

            if (!isAlreadySelected) {
              selectFilterOption(option, activeIndex);
            }
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [filterData, activeIndex, isOpen, filtersOptionsSelected]);

  useEffect(() => {
    if (activeOptionRef.current && containerRef.current) {
      activeOptionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && isOpen) {
        // applySelection(filtersOptionsSelected);
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, filtersOptionsSelected]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("resize", applySelection(filtersOptionsSelected));

    return () => {
      window.removeEventListener(
        "resize",
        applySelection(filtersOptionsSelected)
      );
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (typeof filterSearchTerm === "string")
        setDebouncedSearchTerm(filterSearchTerm);
    }, environment.debounceTime);

    return () => {
      clearTimeout(handler);
    };
  }, [filterSearchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm != null) {
      getDropDownData(0, environment.ElemensPerPage, true);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getDropDownData(0, environment.ElemensPerPage, true);
  }, [parentComponentId]);

  useEffect(() => {
    setIsOpen(currentIndexTab);
  }, [currentIndexTab]);

  useEffect(() => {
    const handleDeleteWithKey = (e) => {
      if (e.key == "Delete") {
        if (isOpen) {
          clearAllFilters();
        }
      }
    };

    document.addEventListener("keydown", handleDeleteWithKey);

    return () => {
      document.removeEventListener("keydown", handleDeleteWithKey);
    };
  }, [isOpen]);

  useEffect(() => {
    if (externalOpening && menuRef.current) {
      setIsOpen(true);
    }
  }, [externalOpening]);

  const nullLabelShown =
    !(visibleOptions.length > 0) && Boolean(data.labelWhenIsNull);

  const DropdownItems = ({ index, style }) => {
    const opt = filterData[index];
    return (
      <div
        className="options"
        style={{
          ...style, // Aplicar el estilo proporcionado por react-window
          backgroundColor: filtersOptionsSelected.some(
            (item) => item[primaryLabel] === opt[primaryLabel]
          )
            ? "#DBFFEE"
            : "var(--white-100)",
          border:
            activeIndex === index && data.dropdownType === "Multiple Selection"
              ? "1px solid var(--grey-200)"
              : "",
          width: "100%",
          borderRadius: "0.3rem",
          padding: "0.3rem",
          display: "flex",
          alignItems: "center",
          gap: "var(--gap)",
          cursor: "pointer",
          transition: "var(--transition)",
        }}
        onClick={() => selectFilterOption(opt, index, false, true)}
      >
        {data.dropdownType === "Multiple Selection" && (
          <Checkbox
            checked={filtersOptionsSelected.some(
              (item) => item[primaryLabel] === opt[primaryLabel]
            )}
          />
        )}
        <section>
          <p className="ellipsis">
            <div className="dropdown-main-info">
              <div className="dropdown-main-property">
                <span>PN</span>
                <b>{opt["part_number"]}</b>
              </div>
              <div className="dropdown-main-property">
                <span>SN</span>
                <b>{opt["serial_number"]}</b>
              </div>
              <div className="dropdown-main-property">
                <span>Description</span>
                <b>{opt["description"]}</b>
              </div>
            </div>
          </p>
        </section>
      </div>
    );
  };

  const keyOpen = (event) => {
    // if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
    //   // Execute your code here
    //   // Prevent default action if needed (e.g., prevent scrolling with Spacebar)
    //   event.preventDefault();
    //   toggleMenu();
    // }
    // if (event.key === "Tab" || event.keyCode === 9) {
    //   toggleMenu();
    //   // Execute your code here
    //   // Prevent default action if needed (e.g., prevent focusing next element)
    //   event.preventDefault();
    // }
  };

  return (
    !(disabled && hideWhenDisabled) && (
      <>
        {children ? (
          <div
            tabIndex={0}
            onKeyDown={keyOpen}
            onClick={toggleMenu}
            ref={menuRef}
          >
            {children}
          </div>
        ) : (
          <button
            disabled={disabled}
            tabIndex={0}
            onKeyDown={keyOpen}
            className={`select ${disabled ? "disabled" : ""}`}
            onClick={toggleMenu}
            ref={menuRef}
            style={{
              border: "none",
              background: "none",
              borderRadius: "var(--input-radius)",
              ...(display1Grid ? { gridColumn: "span 1" } : {}),
              ...(display2Grid ? { gridColumn: "span 2" } : {}),
            }}
          >
            <div id="select-partNumber" className={errorLabel ? "error" : ""}>
              <div
                id="selected-options-container"
                className="selected-options-container"
              >
                {[
                  ...(visibleOptions.length > 0
                    ? visibleOptions
                    : Boolean(data.labelWhenIsNull)
                    ? [{ [primaryLabel]: data.labelWhenIsNull }]
                    : []),
                ].map((option, idx) => (
                  <span
                    key={idx}
                    className={`${
                      data.dropdownType == "Multiple Selection"
                        ? "selected-option"
                        : "selected-option-singleSelection"
                    }`}
                  >
                    {option[primaryLabel]}
                  </span>
                ))}
                {(hiddenCount > 0) &
                (data.dropdownType == "Multiple Selection") ? (
                  <span className="hidden-count">{`${hiddenCount}+`}</span>
                ) : null}
              </div>
            </div>

            <label
              htmlFor="select-partNumber"
              style={{
                fontSize:
                  isOpen ||
                  fixedLabel ||
                  nullLabelShown ||
                  visibleOptions.length > 0
                    ? "var(--input-active-label-font-size)"
                    : "",
                top:
                  isOpen ||
                  fixedLabel ||
                  nullLabelShown ||
                  visibleOptions.length > 0
                    ? "-0.9em"
                    : "",
                left: fixedLabel ? "50%" : "",
                transform: fixedLabel
                  ? "TranslateX(-50%) TranslateY(-50%)"
                  : "",
              }}
            >
              {`${required ? "*" : ""}${data.name}`}
            </label>
            {errorLabel && <i className="error-label">{errorLabel}</i>}
            <KeyboardArrowDown
              sx={{
                position: "absolute",
                right: ".2rem",
                cursor: "pointer",
                transform: isOpen ? "rotate(-180deg)" : "",
              }}
            ></KeyboardArrowDown>
          </button>
        )}
        <Popover
          open={Boolean(isOpen)}
          onClose={() => setIsOpen(false)}
          anchorEl={menuRef.current}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {
            <section
              className="data-basic-filters-cont"
              style={{
                minWidth: menuRef?.current?.getBoundingClientRect()?.width,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {data.showApplyFilterBtn ? (
                <button
                  className="bg-black-mid txt-white"
                  id="apply-selection-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    applySelection(filtersOptionsSelected);
                    setIsOpen(false);
                  }}
                >
                  Apply selection
                </button>
              ) : null}

              <p className="data-basic-filters-cont-selectedFiltersName">
                Selected {data.name}
                {data.dropdownType === "Multiple Selection" &&
                  !(clearLabel === null) && (
                    <span onClick={() => clearAllFilters()}>
                      {clearLabel || "Clear filter"}
                    </span>
                  )}
              </p>
              {filtersOptionsSelected?.length > 0 &&
              data.dropdownType == "Multiple Selection" ? (
                <section
                  className="filter-options-selected"
                  onClick={(e) => e.stopPropagation()}
                >
                  {filtersOptionsSelected?.length > 0
                    ? filtersOptionsSelected.map((options, index) => {
                        return (
                          <span key={index}>
                            <p
                              className="ellipsis"
                              style={{
                                fontSize: "0.5rem",
                              }}
                            >
                              {options[primaryLabel]}
                            </p>
                            <Close
                              sx={{
                                fontSize: "var(--p-size)",
                                cursor: "pointer",
                                color: "var(--white)",
                              }}
                              onClick={() => clearOneOptionFilter(options)}
                            ></Close>
                          </span>
                        );
                      })
                    : null}
                </section>
              ) : null}
              <section className="filters-options-cont" ref={containerRef}>
                <div className="search-options-cont">
                  <input
                    type="text"
                    placeholder="Search"
                    autoFocus={isOpen}
                    value={filterSearchTerm}
                    onChange={handleInputChange}
                    onKeyDown={(event) => {
                      if (isOpen && activeIndex !== -1 && event.key === " ") {
                        event.preventDefault();
                      }
                    }}
                  />

                  <img src={searchIcon} alt="" />
                </div>

                <FixedSizeList
                  height={Math.min(filterData.length * 40, 300)}
                  itemCount={filterData.length}
                  itemSize={40}
                  width={"100%"}
                  onItemsRendered={({ visibleStopIndex }) => {
                    if (visibleStopIndex >= filterData.length - 1) {
                      loadMoreItems();
                    }
                  }}
                >
                  {DropdownItems}
                </FixedSizeList>
              </section>
            </section>
          }
        </Popover>
      </>
    )
  );
};
